// src/pages/SellerIntelligence/ProductPerformance/ProductPerformance.js
//
// Product Performance Deep Dive. Sales Performance says which products are
// carrying the business; this page says why — how many people saw a listing,
// how many bought, and how fast stock is moving.
//
// The page carries two periods on purpose, and that is a data constraint rather
// than a design choice. The funnel is built from daily traffic and follows the
// window control. The product table is built from per-ASIN traffic, which
// Amazon publishes only aggregated across the report's coverage window, so it
// states its own period instead of pretending to follow the control.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import styles from '../SellerIntelligence.module.css';
import { WindowControl, useWindowControl } from '../components/WindowControl';
import KpiStrip from './components/KpiStrip';
import SessionsFunnel from './components/SessionsFunnel';
import ConversionTrend from './components/ConversionTrend';
import ProductTable from './components/ProductTable';

const ProductPerformance = () => {
  const navigate = useNavigate();
  const control = useWindowControl();
  // Each card reports what it loaded so the KPI strip can reuse it. State
  // setters are stable, so passing them never retriggers a card's fetch.
  const [funnel, setFunnel] = useState(null);
  const [conversion, setConversion] = useState(null);
  const [table, setTable] = useState(null);

  return (
    <div className={styles.featureContainer}>
      <div className={styles.header}>
        <button
          className={styles.backButton}
          onClick={() => navigate('/dashboard/seller-intelligence/sales')}
        >
          <FiArrowLeft /> Back
        </button>
        <div className={styles.titleSection}>
          <div className={styles.iconTitle}><h1>Product Performance Deep Dive</h1></div>
          <p>
            Why a product is or is not selling. How many people saw the listing,
            how many bought, and how fast stock is moving.
          </p>
        </div>
      </div>

      <div className={styles.content}>
        <WindowControl control={control} />

        <KpiStrip funnel={funnel} conversion={conversion} table={table} />

        <SessionsFunnel window={control.applied} onLoadingChange={control.track('funnel')} onData={setFunnel} />

        <ConversionTrend window={control.applied} onLoadingChange={control.track('conversion')} onData={setConversion} />

        <ProductTable window={control.applied} onLoadingChange={control.track('table')} onData={setTable} />
      </div>
    </div>
  );
};

export default ProductPerformance;
